export default {
  type: 'Medicare',
  sections: [
    { id: 'medicare1', title: 'What is Medicare' },
    { id: 'typesofmedicare', title: 'Types of Medicare' },
    { id: 'htgbr', title: 'How to Get The Best Rate' },
    { id: 'coverage', title: 'Coverages to Look Out For' },
    { id: 'medicare2', title: 'Medicare Pricing Impacts' }
  ],
  typesList: [
    'Original Medicare',
    'Medicare Supplement/Medigap',
    'Medicare Advantage'
  ],
  typesListTitle: 'Types of Medicare',
  introData: {
    title: 'What is Medicare?',
    paragraphs: [
      "Medicare was created in 1965, signed into law by President Lyndon B Johnson. Medicare was designed to be a national health care solution for seniors over the age of 65.",
      "Since Medicare's creation there has been several changes. Most notibly, the expansion of coverages through Medicare Supplements and the advent of Medicare Advantage plans."
    ]
  },
  bestRateTips: [
    "Compare Medicare Advantage plans with Original Medicare plus a supplement to see which offers better value for your specific needs.",
    "Consider your prescription drug needs when selecting a Part D plan or Medicare Advantage plan with drug coverage.",
    "Take advantage of preventive services covered at 100% under Medicare Part B.",
    "Review your coverage choices annually during open enrollment as plans, coverage, and your health needs may change.",
    "If you have specific doctors or facilities you prefer, make sure they're in-network before choosing a Medicare Advantage plan."
  ],
  briefGuide: "Medicare can get confusing with the different coverage options. To help understand how Medicare coverages are offered, we will break it down into a few easy categories.",
  coverageItems: [
    "Part A - Hospital Insurance",
    "Part B - Out of Hospital (Primary Care)",
    "Part C - Medicare Advantage",
    "Part D - Drugs",
    "Medicare Supplement/Medigap"
  ],
  additionalInfo: {
    overview: "Medicare coverages are separated into different parts, each covering specific aspects of your healthcare needs.",
    sections: [
      {
        title: "Part A",
        paragraphs: [
          "The most well known and commonly found coverage within Medicare is part A. The best way to understand Part A is it revolves around the \"hospital\". You will more than likely be using this coverage if you end up in the hospital or you need care after hospitalization.",
          "Ficticious examples of how Part A would be used - Cindy got into a car accident, the car accident resulted in her being admitted to a near-by hosptial. Cindy had to stay at the hospital for a few days while she recovered. She would be using Part A.",
          "Robert comes down with a cold. He needs to visit his primary physician to get a check-up. He would not be using Part A."
        ]
      },
      {
        title: "Part B",
        paragraphs: [
          "This coverage will be used most often for the majority of Medicare recipents. Part B is used for primary care or diagnosing and treating medical conditions that dont require hospitalization. Part B would be for your primary care and for preventative services."
        ]
      },
      {
        title: "Part C",
        paragraphs: [
          "Part C is also known as Medicare Advantage. This is an alternative way to receive your Medicare benefits. Advantage plans are offered by private companies that are approved by Medicare. These plans must cover all of the services that Original Medicare covers."
        ]
      },
      {
        title: "Part D",
        paragraphs: [
          "Part D helps cover the cost of prescription drugs. These plans are run by insurance companies and other private companies approved by Medicare."
        ]
      },
      {
        title: "Medicare Supplement/Medigap",
        paragraphs: [
          "Medicare Supplement is coverages that are additional to Original Medicare. They are primarily used to take care of many of the out-of-pocket costs of Original Medicare. Medicare Supplment policies are sold by private companies that follow guidelines set fourth by the federal government."
        ]
      }
    ]
  },
  pricingFactors: {
    title: "Main Price Impacting Factors for Medicare",
    description: "When comparing rates and coverages for Medicare, it is important to keep in mind data points that Insurance Companies find most important when evaluating your rate.",
    factors: [
      {
        title: "Original Medicare, Medicare Supplement, Medicare Advantage",
        description: "The type of plan you choose will have a major impact on what pricing you will get when it comes to Medicare. While there is a variety of factors to consider, it is generally understood that medicare advantage can come at the least cost, Original Medicare comes as a mid-tier solution and Medicare Supplement as the priciest option.",
        imageUrl: "@/assets/images/productPageImages/multi.png"
      },
      {
        title: "Drugs",
        description: "The type of drugs that you need will have a major impact on your pricing. A drug like Eliquis- a blood thinner can cost as much as $511 (2022), a drug like Loratadine- an allergy medicine can cost around $3 (2022). This vast difference in pricing will ultimately effect pricing with your Medicare plan.",
        imageUrl: "@/assets/images/productPageImages/multi.png"
      },
      {
        title: "Extras",
        description: "If you are interested in additional benefits and coverages like- Vision, Hearing, Dental, Fitness Programs, and Transportation. This can incur higher costs, due to the expanded coverage and benefits you elect.",
        imageUrl: "@/assets/images/productPageImages/credit.png"
      },
      {
        title: "Doctors",
        description: "Depending on if your doctor is a Medicare participating provider, or a non-Medicare participating provider, this can effect your rates in a big way because it will determine what type of plan you will need to sign up for. Check with your doctor to see what insurance they accept.",
        imageUrl: "@/assets/images/productPageImages/marital.png"
      }
    ]
  },
  relatedProducts: [
    {
      title: "Life Insurance",
      imageUrl: "@/assets/images/product-type-icons/lifeInsurance.svg",
      link: "/products/lifeinsurance"
    },
    {
      title: "Home Insurance",
      imageUrl: "@/assets/images/product-type-icons/homeInsurance.svg",
      link: "/products/homeinsurance"
    },
    {
      title: "Health Insurance",
      imageUrl: "@/assets/images/product-type-icons/homeInsurance.svg",
      link: "/products/homeinsurance"
    }
  ],
  ctaText: "(Medicare Supplement, Medicare Advantage, Original Medicare)"
}; 